import classNames from "classnames";
import { type ReactNode } from "react";

export const SummaryLabel = ({
  label,
  value,
  className,
}: {
  label: ReactNode;
  value: ReactNode;
  className?: string;
}) => {
  return (
    <div className={classNames("d-flex flex-justify-between", className)}>
      <span>{label}</span>
      <span>{value}</span>
    </div>
  );
};
